module.exports = __webpack_public_path__ + "img/Portable_handle.b58cd3ec.jpg";